"use client";

import { useEffect, useRef, useState } from "react";

interface ProductTitleProps {
  name: string;
}

/**
 * Ürün başlığı.
 * - Mobil (< sm): tek satır. İsim kutuya sığmıyorsa kayan yazı (marquee),
 *   sığıyorsa sabit durur — gereksiz hareket olmaz.
 * - sm ve üstü: normal başlık (gerekirse satır kaydırır).
 */
export function ProductTitle({ name }: ProductTitleProps) {
  const containerRef = useRef<HTMLSpanElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);
  const [overflow, setOverflow] = useState(false);

  useEffect(() => {
    const check = () => {
      const c = containerRef.current;
      const t = textRef.current;
      if (!c || !t) return;
      // textRef her zaman tek kopya ölçer → durum değişse de ölçüm tutarlı
      setOverflow(t.offsetWidth > c.clientWidth + 1);
    };
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [name]);

  return (
    <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-950 tracking-tight leading-tight">
      {/* Mobil */}
      <span ref={containerRef} className="block overflow-hidden whitespace-nowrap sm:hidden">
        <span className={`inline-flex w-max gap-10 ${overflow ? "animate-marquee" : ""}`}>
          <span ref={textRef} className="whitespace-nowrap">{name}</span>
          {overflow && <span aria-hidden className="whitespace-nowrap">{name}</span>}
        </span>
      </span>
      {/* Masaüstü */}
      <span className="hidden sm:block">{name}</span>
    </h1>
  );
}
